import { useTranslation } from 'react-i18next'
import { Button } from '@dashboard/ui'
import { TableZeroState } from '@/ui'
import { CloseOutline } from '@/icons'

interface PriceTemplateEmptyStateProps {
  onClear: () => void
}

export const PriceTemplateEmptyState = ({ onClear }: PriceTemplateEmptyStateProps) => {
  const { t } = useTranslation('sku-price-templates', { keyPrefix: 'empty-state' })

  return (
    <TableZeroState
      title={t('title')}
      message={t('text')}
      buttons={
        <Button variant="outline" color="secondary" size="sm" onClick={onClear}>
          <CloseOutline size={16} />
          <span>{t('filter.clear-button')}</span>
        </Button>
      }
    />
  )
}
